import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from 'src/app/config/config';
import { Environment } from 'src/app/config/environment';
import { METHOD_TYPE } from 'src/app/constants/service.constants';
import { ServiceRouter } from '../core/http-service-router.service';
import { JwtHelper } from '../core/jwt-helper.service';
import { detect } from 'detect-browser';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';

import { PageScrollService } from 'ngx-page-scroll-core';
import { Router } from '@angular/router';
/**
 * contains api related to health assessment
 */
@Injectable()
export class NewHAService {
	/**
	 * constructor
	 * @param environment
	 * @param serviceRouter
	 * @param config
	 */
	constructor(
		private environment: Environment,
		private serviceRouter: ServiceRouter,
		private config: Config,
		private jwtService: JwtHelper,
		private pageScrollService: PageScrollService,
		private router: Router,
		@Inject(DOCUMENT) private document: any
	) {}

	getHealthHistoryStatus(apptID): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().DASHBOARD_BASE_URL,
			`${this.config.url.dashboard.getHaStatus}?apptId=${apptID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().BASE_DOMAIN
		);
	}

	markComplete(apptID, HaID): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.markComplete}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${HaID}`,
			METHOD_TYPE.SECURED_POST,
			{},
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getBrowser() {
		return detect();
	}
	scroll(target) {
		let element;
		if (target instanceof HTMLElement) {
			element = target;
		} else {
			element = document.getElementById(target) as HTMLElement;
		}
		if (element !== null) {
			element.focus();
			const browser = this.getBrowser();
			switch (browser && browser.name) {
				case 'edge':
				case 'ie':
					element.scrollIntoView({
						block: 'start',
						inline: 'start',
					});
					window.scrollBy(0, -85);
					break;
				default:
					element.scrollIntoView({ behavior: 'smooth', block: 'center' });
					break;
			}
			return true;
		}
		return false;
	}

	isValidIndex(data) {
		return data !== undefined && data !== '' && data !== null && !isNaN(data);
	}
	scrollView(target) {
		const element: HTMLElement = document.getElementById(target) as HTMLElement;
		if (element !== null) {
			try {
				this.pageScrollService.scroll({
					document: this.document,
					scrollTarget: '#' + target,
				});
				return true;
			} catch (e) {
				console.error(`[${NewHAService.name}][${this.scrollView.name}]`, e);
			}
		}
		return false;
	}

	redirect(
		general,
		medical,
		lifestyle,
		apptID,
		healthAssessmentID,
		readOnly,
		section,
		returningUser,
		haCompleted: boolean = false
	) {
		if (returningUser) {
			general = [];
			medical = [];
			lifestyle = [];
			haCompleted = true;
			section = '';
		}
		this.router.navigate(
			[
				'assessment/info',
				{
					outlets: { general: general, medical: medical, lifestyle: lifestyle },
				},
			],
			{
				skipLocationChange: true,
				queryParams: {
					apptID: apptID,
					healthAssessmentID: healthAssessmentID,
					readOnly: readOnly,
					section: section,
					returningUser: returningUser,
					haCompleted: haCompleted,
				},
			}
		);
	}
}
